import React from 'react'
import { Upload, User } from 'lucide-react'
import { getImageUrl } from '@/services/authorService'
import { Input } from '@/components/ui/input'

export function AuthorImageUploader({ image, name, uploading, onUpload, onImageChange }) {
  return (
    <div className="space-y-2">
      <div className="flex h-40 w-full items-center justify-center overflow-hidden rounded-md border border-dashed border-input bg-muted/40">
        {image ? (
          <img src={getImageUrl(image)} alt={name || 'Author preview'} className="h-full w-full object-cover" />
        ) : (
          <User className="h-10 w-10 text-muted-foreground" />
        )}
      </div>
      <label className="flex h-9 w-full cursor-pointer items-center justify-center gap-1.5 rounded-md border border-input text-sm font-medium hover:bg-accent">
        <Upload className="h-4 w-4" />
        {uploading ? 'Uploading...' : 'Upload or change image'}
        <input
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif"
          disabled={uploading}
          className="hidden"
          onChange={(event) => {
            const file = event.target.files?.[0]
            if (file) onUpload(file)
            event.target.value = ''
          }}
        />
      </label>
      <Input
        value={image || ''}
        placeholder="Image URL"
        onChange={(event) => onImageChange(event.target.value)}
      />
    </div>
  )
}
